import React, { useEffect } from 'react';
import { socialMediaJavaScriptSrc } from './enums';

const SocialPostInstagram = ({ model }) => {
    useScript(socialMediaJavaScriptSrc.INSTAGRAM);

    return (
        <div className='social-post__body' dangerouslySetInnerHTML={{ __html: model.body }}>
        </div>
    );
};

const useScript = (url) => {
    useEffect(() => {
        const scriptId = 'instagram-embed';
        const existingScript = document.getElementById(scriptId);

        const script = document.createElement('script');

        if (existingScript !== null) {
            document.body.removeChild(existingScript);
        }

        script.id = scriptId;
        script.src = url;
        script.defer = true;
        script.onload = () => window.instgrm.Embeds.process();

        document.body.appendChild(script);

        // TODO:
        // remove the <script> tag when there
        // are no Instagram posts on the live blog

        // componentWillUnmount()
        // return () => document.body.removeChild(script);
    }, []);
};

export default SocialPostInstagram;
